import gql from "graphql-tag";

export const deleteBatchById = gql`
  mutation DeleteBatch($id: ID) {
    deleteBatch(where: { id: $id }) {
      id
    }
  }
`;
